import { render, staticRenderFns } from "./FilterSettlementBlock.vue?vue&type=template&id=72690fd5&"
import script from "./FilterSettlementBlock.vue?vue&type=script&lang=js&"
export * from "./FilterSettlementBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports